module.exports = __webpack_public_path__ + "img/fluidMechanics.4eca6f96.jpg";